/**
 * openAuthenticatedPdf — öffnet ein PDF vom Backend in neuem Tab,
 * inkl. Bearer-Auth-Header. Nutzt Blob-URL.
 */
import api from "@/lib/api";
import { toast } from "sonner";

export async function openAuthenticatedPdf(path) {
  try {
    const r = await api.get(path, { responseType: "blob" });
    const blob = new Blob([r.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const w = window.open(url, "_blank");
    // Blob-URL nach 60s freigeben
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
    return w;
  } catch (err) {
    const status = err?.response?.status;
    let msg = "PDF konnte nicht geladen werden.";
    if (status === 404) msg = "Dokument nicht gefunden.";
    else if (status === 403) msg = "Keine Berechtigung für dieses Dokument.";
    else if (status === 400) msg = "Anfrage konnte nicht verarbeitet werden.";
    toast.error(msg);
    return null;
  }
}

// iter132.4 — Blob-URL für inline-Vorschau (iframe/embed)
export async function fetchPdfBlobUrl(path) {
  const r = await api.get(path, { responseType: "blob" });
  const blob = new Blob([r.data], { type: "application/pdf" });
  return URL.createObjectURL(blob);
}
